$(document).ready(function () {
    if ($('.jobs-container').length) {
        return;
    }

    // Constant access variables
    const $locationInput = $('#location');
    const $zipInput = $('#zip');
    const $cityInput = $('#city');
    const $stateInput = $('#state');
    const $radiusInput = $('#radius');
    const $distanceContainer = $('#distance_container');
    let locationRequestGeneration = 0;
    let activeLocationRequest = null;

    /**
     * Toggle the "Within Distance" dropdown hidden or shown.
     * @param {'show'|'hide'} action
     */
    const toggleDistanceOption = (action) => {
        if (action === 'show') {
            $radiusInput.prop('disabled', false);
            $distanceContainer.val(['100']);
            $distanceContainer.removeClass('d-none');
            $distanceContainer.addClass('d-inline-block');
        } else if (action === 'hide') {
            $distanceContainer.addClass('d-none');
            $distanceContainer.removeClass('d-inline-block');
            $radiusInput.prop('disabled', true);
        }
    };

    /**
     * @param {string|int} zip
     * @returns {boolean}
     */
    const mayBeValidZip = (zip) => {
        return $.isNumeric(zip) && zip.length === 5;
    };

    /**
     * @param {object} result
     * @property {string} text
     * @property {string|int} id
     */
    const setLocationValue = (result) => {
        const option = new Option(result.text, result.id, true, true);
        $locationInput.append(option).val(result.id).trigger('change');
    };

    /**
     * @param {string|int} searchTerm
     * @returns {JQueryXHR}
     */
    const getLocationData = (searchTerm) => {
        const requestGeneration = ++locationRequestGeneration;

        activeLocationRequest?.abort?.();

        const request = $.ajax({
            url: $locationInput.data('source'),
            type: 'GET',
            data: {
                term: searchTerm,

                include_zips: $.isNumeric(searchTerm) ? 1 : 0,
            },
            success: ({ results }) => {
                if (requestGeneration !== locationRequestGeneration) {
                    return;
                }

                const def = $.Deferred();

                if (results.length > 0) {
                    const result = results[0];

                    setLocationValue(result);

                    if (result.zip) {
                        toggleDistanceOption('show');
                        $zipInput.val(result.zip);
                        $stateInput.val('');
                    } else if (result.state) {
                        $zipInput.val('');
                        $stateInput.val(result.state);
                        toggleDistanceOption('hide');
                    }
                } else {
                    toggleDistanceOption('hide');
                    $zipInput.val('invalid');
                    $stateInput.val('invalid');
                }

                return def.promise();
            },
        });

        activeLocationRequest = request;
        request.always(() => {
            if (activeLocationRequest === request) {
                activeLocationRequest = null;
            }
        });

        return request;
    };

    /**
     * @returns {Promise<void>|JQueryXHR}
     */
    const checkLocationValidity = () => {
        const locVal = $.trim($locationInput.val());

        if (!locVal) {
            $zipInput.val('');
            $stateInput.val('');
            $radiusInput.val('');

            return Promise.resolve();
        }

        if (
            locVal.length < 2 ||
            $.isNumeric(locVal) && !mayBeValidZip(locVal)
        ) {
            // Invalid zip code
            $zipInput.val('invalid');
            $stateInput.val('invalid');

            return Promise.resolve();
        }

        if (mayBeValidZip(locVal)) {
            toggleDistanceOption('show');
            $zipInput.val(locVal);
            $stateInput.val('');
        }

        return getLocationData(locVal);
    };

    // Location autocomplete
    if ($locationInput.length) {
        $locationInput.select2({
            minimumInputLength: 2,
            ajax: {
                url: $locationInput.data('source'),
                dataType: 'json',
                delay: 500,
                data: ({ term }) => ({
                    term: term,

                    include_zips: $.isNumeric(term) ? 1 : 0,
                }),
            },
            theme: 'dark',
            placeholder: $locationInput.attr('placeholder'),
            allowClear: true,
        });

        $locationInput.on('select2:select', function (e) {
            const data = e.params.data;
            setLocationValue(data);

            if (data?.state) {
                toggleDistanceOption('hide');
                $stateInput.val(data.id);
                $zipInput.val('');
            }

            if (data?.zip) {
                toggleDistanceOption('show');
                $stateInput.val('');
                $zipInput.val(data.zip);
                $radiusInput.val('100');
            }
        });

        $locationInput.on('select2:clear', function () {
            locationRequestGeneration++;
            activeLocationRequest?.abort?.();
            activeLocationRequest = null;
            toggleDistanceOption('hide');
            $cityInput.val('');
            $stateInput.val('');
            $zipInput.val('');
            $radiusInput.val('');
        });

        if ($locationInput.data('value')) {
            getLocationData($locationInput.data('value'));
        }
    }

    // Search form submission
    $('.submit_basic_search, #mobile_search_btn').on('click', function () {
        $(this).attr('disabled', 'disabled');

        checkLocationValidity().then(() => {
            $('.basic-search').submit();
        });
    });
});
